export class RegulationPaymentTotal {
  regulationId: string;
  totalAmount: number;
}
